import React, { useEffect, useState } from "react";
import api from "../lib/api";

/** Load private photo bytes through the authenticated API client, never an img URL. */
export default function PrivatePlayerPhoto({ player, clubId, className = "h-10 w-10", alt, refreshVersion = 0, knownAbsent = false, onAvailabilityChange }) {
    const [objectUrl, setObjectUrl] = useState("");

    useEffect(() => {
        if (!player?.id || !clubId || knownAbsent) {
            setObjectUrl("");
            return undefined;
        }
        setObjectUrl("");
        let active = true;
        let createdUrl = "";
        api.get(`/players/${player.id}/photo`, {
            params: { club_id: clubId },
            responseType: "blob",
        }).then((response) => {
            if (!active) return;
            createdUrl = URL.createObjectURL(response.data);
            setObjectUrl(createdUrl);
            onAvailabilityChange?.(player.id, true);
        }).catch(() => {
            if (active) {
                setObjectUrl("");
                onAvailabilityChange?.(player.id, false);
            }
        });
        return () => {
            active = false;
            if (createdUrl) URL.revokeObjectURL(createdUrl);
        };
    }, [clubId, player?.id, refreshVersion, knownAbsent, onAvailabilityChange]);

    const initials = `${player?.first_name?.[0] || ""}${player?.last_name?.[0] || ""}`;
    return <div className={`${className} shrink-0 overflow-hidden rounded-full bg-slate-100 flex items-center justify-center`}>
        {objectUrl
            ? <img className="h-full w-full object-cover" src={objectUrl} alt={alt || `${player.first_name} ${player.last_name}`} />
            : <span className="text-xs font-bold text-slate-400" aria-label={alt || "Photo indisponible"}>{initials}</span>}
    </div>;
}
